export default "__VITE_ASSET__Dg9s9A8f__"